import React from 'react'
import Headers from '../components/Headers'
import Footer from '../components/Footer'

const ReturnRefundPolicy = () => {
    return (
        <div className='w-full'>
            <Headers />
            <div className='w-[85%] mx-auto py-16'>
                <div className='bg-white rounded-lg p-8'>
                    <h1 className='text-3xl font-bold mb-2 text-gray-900'>Return & Refund Policy</h1>
                    <p className='mb-8 text-gray-500 text-sm'>Last updated: April 2026</p>

                    <div className='space-y-8 text-gray-700'>

                        <section>
                            <h2 className='text-xl font-semibold mb-3 text-gray-900'>1. Escrow-Based Payment System</h2>
                            <p className='mb-3'>OMAH operates on an escrow model. When you place an order, your payment is not held by OMAH directly — it is securely held by our licensed payment partner, <strong>Flutterwave</strong>, until the transaction is confirmed.</p>
                            <p>Funds are only released to the seller <strong>after the buyer confirms receipt and satisfaction</strong> of the order. This ensures your money is protected throughout the entire transaction.</p>
                        </section>

                        <section>
                            <h2 className='text-xl font-semibold mb-3 text-gray-900'>2. Refund Eligibility</h2>
                            <p className='mb-3'>You may be eligible for a refund if:</p>
                            <ul className='list-disc pl-6 space-y-2'>
                                <li>You have <strong>not yet confirmed receipt</strong> of the order</li>
                                <li>The item received is significantly different from what was described</li>
                                <li>The item arrived damaged or defective</li>
                                <li>The seller failed to dispatch the order within the agreed timeframe</li>
                            </ul>
                            <p className='mt-3'><strong>Refund requests must be raised before you confirm receipt of the order.</strong> Once you confirm delivery, funds are released to the seller and a refund may no longer be possible.</p>
                        </section>

                        <section>
                            <h2 className='text-xl font-semibold mb-3 text-gray-900'>3. How to Request a Refund</h2>
                            <ol className='list-decimal pl-6 space-y-2'>
                                <li>Go to <strong>My Orders</strong> in your dashboard</li>
                                <li>Select the relevant order and click <strong>Request Return / Refund</strong></li>
                                <li>Provide your reason and any supporting evidence (photos, messages)</li>
                                <li>Our team will review the request and respond within 3–5 business days</li>
                                <li>If approved, the refund will be processed back to your original payment method</li>
                            </ol>
                        </section>

                        <section>
                            <h2 className='text-xl font-semibold mb-3 text-gray-900'>4. Buyer–Seller Dispute Handling</h2>
                            <p className='mb-3'>If there is a disagreement between a buyer and seller regarding an order, OMAH provides a structured dispute process:</p>
                            <ul className='list-disc pl-6 space-y-2'>
                                <li>Either party may open a dispute through the platform before order confirmation</li>
                                <li>Both parties will be given the opportunity to provide evidence</li>
                                <li>OMAH's support team will review all submissions and make a fair determination</li>
                                <li>During an active dispute, funds remain held in escrow and are not released to either party</li>
                                <li>OMAH's decision on disputes is final unless overturned by relevant legal authority</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className='text-xl font-semibold mb-3 text-gray-900'>5. Fraud Protection</h2>
                            <p className='mb-3'>OMAH takes fraud seriously. The following are prohibited and may result in immediate account suspension and legal action:</p>
                            <ul className='list-disc pl-6 space-y-2'>
                                <li>Sellers dispatching empty packages or incorrect items intentionally</li>
                                <li>Buyers falsely claiming non-receipt after goods have been delivered</li>
                                <li>Any attempt to manipulate the escrow release process</li>
                                <li>Creating fake accounts or transactions to abuse the refund system</li>
                            </ul>
                            <p className='mt-3'>All suspicious activity is monitored and may be reported to Flutterwave and relevant authorities.</p>
                        </section>

                        <section>
                            <h2 className='text-xl font-semibold mb-3 text-gray-900'>6. Non-Refundable Items</h2>
                            <ul className='list-disc pl-6 space-y-2'>
                                <li>Digital products and downloadable content</li>
                                <li>Custom or personalised orders</li>
                                <li>Items confirmed as received by the buyer</li>
                                <li>Services already rendered</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className='text-xl font-semibold mb-3 text-gray-900'>7. Refund Timelines</h2>
                            <p>Once a refund is approved, processing times depend on your payment method and may take <strong>5–10 business days</strong> to reflect. OMAH is not responsible for delays caused by banks or payment processors.</p>
                        </section>

                        <section>
                            <h2 className='text-xl font-semibold mb-3 text-gray-900'>8. Contact & Support</h2>
                            <p>For any refund or dispute queries, reach us through the <strong>Help & Support</strong> section in your dashboard or contact us via the OMAH platform support channels.</p>
                        </section>

                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default ReturnRefundPolicy
     